import { SVGProps } from "react";

const IconVisa = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="28"
    height="27"
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.22651 1H22.1018C22.7779 1 23.3283 1.54995 23.3283 2.22533V13.8225C23.3283 14.4979 22.7779 15.0479 22.1018 15.0479H2.22651C1.55048 15.0479 1 14.4979 1 13.8225V2.22533C1 1.54995 1.55048 1 2.22651 1Z"
      fill="white"
      stroke="#736967"
      strokeWidth="0.253586"
      strokeMiterlimit="10"
    />
    <path
      d="M8.2238 5.03296L6.61098 9.11417L5.95427 5.65045C5.89632 5.30311 5.59694 5.04261 5.2396 5.04261H2.60308L2.56445 5.21628C3.10528 5.33206 3.72336 5.52502 4.09035 5.72763C4.32213 5.85306 4.38008 5.95919 4.45734 6.25829L5.69351 11.0342H7.3353L9.84627 5.04261H8.2238V5.03296Z"
      fill="url(#paint0_linear_1097_4387)"
    />
    <path
      d="M10.5227 5.03223L9.23828 11.0238H10.7932L12.068 5.03223H10.5227Z"
      fill="url(#paint1_linear_1097_4387)"
    />
    <path
      d="M20.5075 5.03223H19.1844C18.8947 5.03223 18.6339 5.2059 18.5277 5.4664L16.2002 11.0238H17.8323L18.1607 10.1265H20.1501L20.3433 11.0238H21.7726L20.5075 5.03223ZM18.5953 8.90118L19.4162 6.65314L19.8797 8.90118H18.5953Z"
      fill="url(#paint2_linear_1097_4387)"
    />
    <path
      d="M14.1046 6.69203C14.1143 6.47977 14.3171 6.24821 14.7613 6.19032C15.2828 6.14208 15.814 6.22891 16.2872 6.46047L16.5576 5.1869C16.0941 5.01323 15.6015 4.9264 15.109 4.91675C13.5734 4.91675 12.5014 5.7272 12.4918 6.89464C12.4821 7.75334 13.2644 8.23575 13.8438 8.5252C14.4523 8.81465 14.6551 9.00761 14.6454 9.26812C14.6454 9.67334 14.1625 9.84701 13.7183 9.85666C12.936 9.86631 12.4821 9.6444 12.1248 9.48038L11.8447 10.7925C12.2021 10.9566 12.8781 11.1013 13.5734 11.1109C15.2056 11.1109 16.2679 10.3101 16.2776 9.0655C16.2872 7.48319 14.0853 7.39635 14.1046 6.69203Z"
      fill="url(#paint3_linear_1097_4387)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1097_4387"
        x1="-5.99586"
        y1="8.02875"
        x2="92.6167"
        y2="8.02875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#222357" />
        <stop offset="1" stopColor="#254AA5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1097_4387"
        x1="5.90815"
        y1="8.02801"
        x2="44.2583"
        y2="8.02801"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#222357" />
        <stop offset="1" stopColor="#254AA5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1097_4387"
        x1="9.66409"
        y1="8.028"
        x2="84.94"
        y2="8.028"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#222357" />
        <stop offset="1" stopColor="#254AA5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1097_4387"
        x1="6.30951"
        y1="8.02011"
        x2="70.1131"
        y2="8.02011"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#222357" />
        <stop offset="1" stopColor="#254AA5" />
      </linearGradient>
    </defs>
  </svg>
);

export default IconVisa;
